/** 案件：ステータスアイコン 閲覧申請前（公募） */
export const RFP_ICON_VIEW = {
    label: '閲覧申請前',
    value: 'no_view',
};
/** 案件：ステータスアイコン 閲覧申請前（RFI・業務委託） */
export const RFP_ICON_NO_VIEW_REQUEST = {
    label: '閲覧申請前',
    value: 'no_view_request',
};
/** 案件：ステータスアイコン 閲覧申請前 */
export const RFP_ICON_VIEW_REQUEST = {
    label: '閲覧申請中',
    value: 'view_request',
};
/** 案件：ステータスアイコン 閲覧不可 */
export const RFP_ICON_REJECT_VIEW_REQUEST = {
    label: '閲覧不可',
    value: 'reject_view_request',
};
/** 案件：ステータスアイコン 意向未登録 */
export const RFP_ICON_OFFER_CONSIDERATION = {
    label: '意向未登録',
    value: 'offer_consideration',
};
/** 案件：ステータスアイコン 提案予定 */
export const RFP_ICON_OFFER_PLANNING = {
    label: '提案予定',
    value: 'offer_planning',
};
/** 案件：ステータスアイコン 提案済み */
export const RFP_ICON_OFFER_DONE = {
    label: '提案済み',
    value: 'offer_done',
};
/** 案件：ステータスアイコン 提案辞退 */
export const RFP_ICON_OFFER_REFUSE = {
    label: '提案辞退',
    value: 'offer_refuse',
};
/** 案件：ステータスアイコンの一覧 */
export const RFP_ICONS = [
    RFP_ICON_VIEW,
    RFP_ICON_NO_VIEW_REQUEST,
    RFP_ICON_VIEW_REQUEST,
    RFP_ICON_OFFER_CONSIDERATION,
    RFP_ICON_OFFER_PLANNING,
    RFP_ICON_OFFER_DONE,
    RFP_ICON_OFFER_REFUSE,
    RFP_ICON_REJECT_VIEW_REQUEST,
];
